import React, { Component } from "react";
import { buildExcelRequestBodyPenjualanByPromo, getConfigByPromo, monthOptions, yearOptions } from "./config";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import * as R from "ramda";
import moment from "moment";
import { saveAs } from "file-saver";
class LaporanPenjualanByPromo extends Component {
  constructor(props) {
    super(props);
    this.currentMonth = Number(moment().format("MM"));
    this.currentYear = Number(moment().format("YYYY"));
    this.state = {
      month: monthOptions.find((item) => item.value === this.currentMonth),
      year: yearOptions.find((item) => item.value === this.currentYear),
      tableConfig: getConfigByPromo(this.currentYear),
      dataTable: [],
      rawData: null,
    };
  }

  componentDidMount() {}

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  constructData = (apiData) => {
    if (!Array.isArray(apiData)) {
      return { rows: [], promoList: [] };
    }

    const promoList = R.uniq(
      apiData.flatMap((cabang) =>
        (cabang.dataPromo || []).map((p) => p.namaPromo),
      ),
    );

    const rows = apiData.map((cabang) => {
      const row = { namaCabang: cabang.namaCabang };

      promoList.forEach((promo) => {
        row[promo] = 0;
      });

      (cabang.dataPromo || []).forEach((promo) => {
        row[promo.namaPromo] = promo.totalPenjualan;
      });

      return row;
    });

    return { rows, promoList };
  };

  fetchData = async () => {
    const { onTriggerLoading, search } = this.props;
    const { month, year } = this.state;

    if (!search) return;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanFjbByPromo,
      menuName: "Dashboard Kabeng Keatas - Laporan FJB By Promo",
      args: {
        listCabang: this.props.search,
        year: year?.value,
        month: month?.value,
      },
    });

    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const { rows, promoList } = this.constructData(res.data.data);

      this.setState({
        dataTable: rows,
        tableConfig: getConfigByPromo(promoList),
        rawData: res.data.data,
      });
    }
  };

  handleSearch = () => {
    this.fetchData();
  };

  handlePrint = async () => {
    const { onTriggerLoading } = this.props;
    const { month, year, dataTable, rawData } = this.state;
    onTriggerLoading();

    try {
      const reqBody = buildExcelRequestBodyPenjualanByPromo({
        month,
        year,
        dataTable,
        rawData,
      });

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
        menuName: "Dashboard Level Mekanik dan SA - Laporan Penjualan By Promo",
        setError: this.props.setError,
        args: reqBody,
      });

      if (res?.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, `${reqBody.filename}.xlsx`);
      }
    } catch (error) {
      console.error("Error saat generate Excel:", error);
      this.props.setError("Gagal generate file Excel");
    } finally {
      onTriggerLoading();
    }
  };

  render() {
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            menuPosition="fixed"
            options={monthOptions}
            value={this.state.month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <p className="margin-bottom-20px" style={{ fontWeight: "bold" }}>
          LAPORAN FJB BY PROMO
        </p>
        {this.state.dataTable.length > 0 && (
          <div style={{ marginBottom: 30 }}>
            <SimpleDataTable
              data={this.state.dataTable}
              columns={this.state.tableConfig}
              options={{ pagination: false }}
            />
          </div>
        )}

        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton id="btn_print" text="CETAK" onClick={this.handlePrint} />
        </FlexView>
      </>
    );
  }
}

export default LaporanPenjualanByPromo;
